export class FranchiseShort {
    id?: number;
    name?: string;

    static fromJson(fields: any): FranchiseShort {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
